/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnLeftDownIcon16Light } from './ArrowDUturnLeftDownIcon16Light';
import { ArrowDUturnLeftDownIcon16Regular } from './ArrowDUturnLeftDownIcon16Regular';
import { ArrowDUturnLeftDownIcon16Solid } from './ArrowDUturnLeftDownIcon16Solid';
import { ArrowDUturnLeftDownIcon20Light } from './ArrowDUturnLeftDownIcon20Light';
import { ArrowDUturnLeftDownIcon20Regular } from './ArrowDUturnLeftDownIcon20Regular';
import { ArrowDUturnLeftDownIcon20Solid } from './ArrowDUturnLeftDownIcon20Solid';
import { ArrowDUturnLeftDownIcon24Regular } from './ArrowDUturnLeftDownIcon24Regular';
import { ArrowDUturnLeftDownIcon24Solid } from './ArrowDUturnLeftDownIcon24Solid';
import { ArrowDUturnLeftDownIcon32Regular } from './ArrowDUturnLeftDownIcon32Regular';
import { ArrowDUturnLeftDownIcon64Regular } from './ArrowDUturnLeftDownIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnLeftDownIcon16Light,
        regular: ArrowDUturnLeftDownIcon16Regular,
        solid: ArrowDUturnLeftDownIcon16Solid,
    },
    20: {
        light: ArrowDUturnLeftDownIcon20Light,
        regular: ArrowDUturnLeftDownIcon20Regular,
        solid: ArrowDUturnLeftDownIcon20Solid,
    },
    24: {
        regular: ArrowDUturnLeftDownIcon24Regular,
        solid: ArrowDUturnLeftDownIcon24Solid,
    },
    32: {
        regular: ArrowDUturnLeftDownIcon32Regular,
    },
    64: {
        regular: ArrowDUturnLeftDownIcon64Regular,
    },
};
export var ArrowDUturnLeftDownIcon = forwardRef('ArrowDUturnLeftDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
